module.exports = __webpack_public_path__ + "media/images/emblems/Teuffenthal-coat_of_arms-8eaa966ba87b149254d3a4bfae23ff44.svg";